"use strict";
/**
 * Kriptonio Private API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: private
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiErrorCode = void 0;
exports.ApiErrorCode = {
    Unknown: 10000,
    Unauthorized: 10001,
    SubscriptionQuotaExceeded: 10002,
    Forbidden: 10003,
    CompilationFailed: 10004,
    GetContractsFailed: 10006,
    UserNotFound: 10007,
    FormValidationFailed: 10008,
    OrganizationNotFound: 10009,
    UserAlreadyExist: 10011,
    SmartContractNotFound: 10013,
    SmartContractNotDeployed: 10015,
    PasswordWeak: 10018,
    TwoFactorAlreadyEnabled: 10019,
    TwoFactorMissingSetup: 10020,
    TwoFactorCodeInvalid: 10021,
    TwoFactorNotEnabled: 10022,
    TwoFactorTooManyFailedAttempts: 10023,
    MissingTwoFactorCode: 10024,
    ActivationMissing: 10026,
    BlockchainNotFound: 10027,
    SubscriptionPlanNotFound: 10029,
    SolCompilerTemporaryUnavailable: 10032,
    BlockchainEndpointServiceTemporaryUnavailable: 10033,
    CannotGetUserInfo: 10040,
    UserAuthenticatedWithDifferentMethod: 10041,
    InvalidAccessToken: 10042,
    CannotActivateAuthMethod: 10043,
    CannotGenerateSlug: 10048,
    UserAlreadyInvited: 10049,
    InvitationNotFound: 10050,
    InvitationEmailMismatch: 10051,
    CannotInviteToPersonalOrganization: 10052,
    CannotUpdatePersonalOrganization: 10053,
    CannotRemoveYourself: 10054,
    MemberNotFound: 10055,
    SubscriptionProductNotFound: 10056,
    SubscriptionMetadataNotFound: 10057,
    PaymentSessionMissing: 10058,
    CannotFindActiveSubscription: 10059,
    SubscriptionNotFound: 10060,
    CannotFindSubscriptionLimit: 10061,
    SubscriptionDataMissing: 10062,
    OAuthDataIncomplete: 10064,
    AppleVerificationFailed: 10065,
    OAuthEmailMissing: 10066,
    EmailMissing: 10068,
    InvalidCode: 10069,
    TemplateNotFound: 10070,
    TemplateInputInvalid: 10071,
    UserNotActive: 10073,
    OrganizationCacheClearFailed: 10074,
    PaymasterServiceUnavailable: 10076,
    SmartContractsExist: 10077,
    TokenFetchingError: 10078,
    TokenMetadataFetchingError: 10079
};
